import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, FileTextIcon } from 'lucide-react';
interface TermsScreenProps {
  onBack: () => void;
  onAccept: () => void;
}
export function TermsScreen({
  onBack,
  onAccept
}: TermsScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="w-full min-h-screen flex flex-col py-6 px-6" style={{
    backgroundColor: '#FFF5F0'
  }} data-id="element-975">
      {/* Header */}
      <div className="flex items-center justify-between mb-8" data-id="element-976">
        <button onClick={onBack} className="p-2 -ml-2 rounded-full hover:bg-black/5 transition-colors" data-id="element-977">
          <ArrowLeftIcon className="w-6 h-6 text-[#1A1A1A]" strokeWidth={2} data-id="element-978" />
        </button>
        <img src="https://cdn.magicpatterns.com/uploads/k5mzauqmFki77bNt7CFYh1/Whatsapp_digiBOP-removebg-preview.png" alt="digiBOP Logo" className="h-8 w-auto" data-id="element-979" />
        <div className="w-10" data-id="element-980" />
      </div>

      {/* Title */}
      <div className="mb-6" data-id="element-981">
        <div className="w-12 h-12 rounded-full bg-[#FCECE3] flex items-center justify-center mb-4" data-id="element-982">
          <FileTextIcon className="w-6 h-6 text-[#D95A1A]" strokeWidth={2} data-id="element-983" />
        </div>
        <h1 className="text-[32px] font-bold text-[#1A1A1A] leading-tight mb-1 tracking-tight" data-id="element-984">
          Terms & Conditions
        </h1>
        <p className="text-[15px] text-[#C85A1A]" data-id="element-985">
          Please read and accept to continue
        </p>
      </div>

      {/* Content */}
      <div className="flex-1 bg-white rounded-3xl p-6 shadow-sm overflow-y-auto mb-6 border border-[#FCECE3]" data-id="element-986">
        <div className="space-y-4 text-[14px] text-[#4A3B32] leading-relaxed" data-id="element-987">
          <p className="font-bold text-[#1A1A1A]" data-id="element-988">1. Acceptance of Terms</p>
          <p data-id="element-989">
            By accessing and using the digiBOP mobile banking application, you
            agree to be bound by these Terms and Conditions.
          </p>

          <p className="font-bold text-[#1A1A1A] mt-4" data-id="element-990">2. User Registration</p>
          <p data-id="element-991">
            You must provide accurate and complete information during the
            registration process, including your valid CNIC.
          </p>

          <p className="font-bold text-[#1A1A1A] mt-4" data-id="element-992">3. Account Security</p>
          <p data-id="element-993">
            You are responsible for maintaining the confidentiality of your MPIN
            and account details. The bank will never ask for your MPIN or OTP.
          </p>

          <p className="font-bold text-[#1A1A1A] mt-4" data-id="element-994">4. Transactions</p>
          <p data-id="element-995">
            All transactions processed through the app are subject to
            verification and available balance. Standard limits and charges
            apply as per the bank's schedule of charges.
          </p>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="pb-4" data-id="element-996">
        <button onClick={onAccept} className="w-full bg-gradient-to-r from-[#D95A1A] to-[#B84A12] text-white py-4 rounded-full font-bold text-[15px] tracking-wide shadow-[0_8px_20px_rgba(217,90,26,0.3)] hover:shadow-[0_8px_25px_rgba(217,90,26,0.4)] active:scale-[0.98] transition-all" data-id="element-997">
          ACCEPT & CONTINUE
        </button>
      </div>
    </motion.div>;
}